import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import Common from './Common';
import Auth from './Auth';
import Loads from './Loads';
import Trips from './Trips';
import Cities from './Cities';
import Users from './Users';
import Tracking from './tracking';
import UserInterests from './UserInterests';
import Workbook from './Workbook';
import Lanes from './Lanes';
import Dashboard from './Dashboard';

export default history =>
  combineReducers({
    router: connectRouter(history),
    common: Common,
    auth: Auth,
    loadsReducer: Loads,
    tripsReducer: Trips,
    citiesReducer: Cities,
    users: Users,
    tracking: Tracking,
    userInterests: UserInterests,
    workbook: Workbook,
    lanes: Lanes,
    dashboard: Dashboard
  });
